import { TServiceTicketSupplyItem, TSupply } from "~/types";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import {
  CreateSupplyParams,
  GetSuppliesParams,
  UpdateSupplyParams,
} from "./supply.type";

export const supplyServices = {
  getSupplies: async (params?: GetSuppliesParams) => {
    const { data } = await baseService.get<PaginationResponse<TSupply>>(
      "/supplies",
      { params }
    );
    return data;
  },
  getServiceTicketSupplies: async (serviceTicketId: string) => {
    const { data } = await baseService.get<TServiceTicketSupplyItem[]>(
      `/supplies/service-ticket/${serviceTicketId}`
    );
    return data;
  },
  getSupply: async (id: string) => {
    const { data } = await baseService.get<TSupply>(`/supplies/${id}`);
    return data;
  },
  createSupply: async (params: CreateSupplyParams) => {
    const { data } = await baseService.post<TSupply>("/supplies", params);
    return data;
  },
  updateSupply: async ({
    id,
    ...params
  }: UpdateSupplyParams & { id: string }) => {
    const { data } = await baseService.patch<TSupply>(
      `/supplies/${id}`,
      params
    );
    return data;
  },
  deleteSupply: async (id: string) => {
    const { data } = await baseService.delete<TSupply>(`/supplies/${id}`);
    return data;
  },
};
